import { defineMessages } from 'react-intl';

/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	linkExternalIconLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	linkExternalIconLabel: {
		id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
		description: 'Label for the link external icon',
		defaultMessage: 'Open external link icon',
	},
});
